//задание статуса аб-тестирования
export function abTestInit () {
    let result;
    if (window.sessionStorage.getItem('AbTest') !== null) {
        result = checkState();
    } else {
        //если состояние для аб-тестирования не было задано в localStorage
        window.sessionStorage.setItem('AbTest', JSON.stringify({date: new Date(), init: setState()}))
        result = checkState();
    }
    return result;
}


//генерация true или false
function setState() {
    return (Math.floor(Math.random() * 2) === 0);
}

function checkState() {
    const abTest = JSON.parse(window.sessionStorage.getItem('AbTest'));
    const currentDate = new Date();
    const saveDate = new Date(abTest.date);
    //если сохраненный день и месяц совпадают c текущим днем
    //не меняем состояние ab-теста
    if (saveDate.getMonth() == currentDate.getMonth() && saveDate.getDate() == currentDate.getDate()) {
        return abTest.init;
    } else { //иначе установим новое состояние и дату
        const state = setState();
        window.sessionStorage.setItem('AbTest', JSON.stringify({date: currentDate, init: state}))
        return state;
    }
}

//сбор и отправка данных на сервер
export const aBtesting = (user={}) => {
    //адрес бека 
    const BACKEND_URL = process.env.REACT_APP_HOST + 'api/abtest';

    //функция отправки данных на сервер
    async function fetcSendAbTestData(data) {
        const response = await fetch(BACKEND_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(data)
        });
        if (response.ok) {
            const responseData = await response.json(); 
            console.log(responseData);
        } else {
            console.log('Ошибка', response.status);
        } 
    }

    /*функция получает целевой элемент с которым работал пользователь
    и формирует объект данных для отправки на сервер*/
    const setABtestData = (target) => {
        const state = abTestInit();
        let fullName;
        let ID;
        
        //если пользователь авторизован - берем его данные: полное имя и id
        if (user.hasOwnProperty('name') && user.hasOwnProperty('surname')) {
            fullName =  `${user.name} ${user.surname}`
        } else {
            fullName = 'Гость'
        }

        if (user.hasOwnProperty('_id')) ID = user._id
        else ID = false

        const abTestData = {
            userName: fullName,
            userID: ID,
            target: target,
            abtestState: state
        }
        return abTestData
    }

    //функция сбора статистики поклику ссылки
    const sendToLink = (e) => {
        const target = e.target.textContent;
        const data = setABtestData(target);
        fetcSendAbTestData(data);
    }


    /*возвращаемый объект с набором функций в зависимости от задач
     пока только под отправку данных по клику на ссылкy*/
    return {
        send: sendToLink
    }
}


// WEBPACK FOOTER //
// ./src/abtest/abtest.js